import script from "./UserHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHeader.vue?vue&type=script&setup=true&lang=ts"

import "./UserHeader.vue?vue&type=style&index=0&id=12bf0305&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bf0305"]])

export default __exports__